
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const WRAPPER_STYLE = {
    width: '100%',
    position: 'relative',
};

export const SeacrhInput = styled.div`
    max-width: 330px;
    width: 100%;
    height: 48px;
    position: relative;
    @media (max-width: 400px) {
        max-width: 100%;
    }
`;
export const Input = styled.input`
    width: 100%;
    height: 48px;
    border: 1px solid ${COLORS.grey};
    border-radius: 4px;
    ${FONTS.S};
    padding: 15px 52px 15px 16px;
    transition: border-color linear .2s;
    &:hover,
    &:focus {
        border-color: ${COLORS.black};
        outline: none;
    }
`;
export const SearchItem = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    background-color: ${props => props.active ? COLORS.lightGrey : '#fff'};
    padding: 7px 14px;
    cursor: pointer;
`;
export const SearchButton = styled.img`
    width: 20px;
    height: 20px;
    position: absolute;
    top: 15px;
    right: 16px;
    border: none;
    background-color: transparent;
    padding: 0;
    outline: 0;
    cursor: pointer;
`;
export const ChannelLogo = styled.img`
    width: 43px;
    height: 43px;
    margin-right: 10px;
    @media (max-width: 1280px) {
        margin-bottom: 5px;
    }
`;

export const Dropdown = styled.div`
    width: 100%;
    max-height: 300px;
    position: absolute;
    left: 0;
    top: 48px;
    overflow-y: auto;
    background: ${COLORS.white};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    z-index: 11;
`;

export const NothingFoundWrapper = styled.div`
    width: 100%;
    padding: 40px;
    ${FONTS.S};
    text-align: center;
    justify-content: center;
    @media (max-width: 400px) {
        padding: 30px 20px;
    }
`;
export const NothingFoundTitle = styled.div`
    margin-bottom: 10px;
`;
